/**
 * 5.0j Locked-language client-facing surface — Stage 2 variant.
 *
 * Two jobs:
 *  1. Persist the URL `:stage2Token` (which IS the stage_2_token Bearer, A1) into
 *     sessionStorage SYNCHRONOUSLY on first render, so the consent GET + the
 *     RequireStage2Session guard + every stage2Fetch can read it on the same paint.
 *     The write is idempotent (only when it differs) — safe under StrictMode double-render.
 *  2. Pin i18n.changeLanguage(position.language) from the video-consent query (5.0j).
 *     The admin global language toggle does NOT propagate to /c/stage2/* (separate tree).
 */
import { useEffect } from "react";
import { Outlet, useParams } from "react-router";
import { useTranslation } from "react-i18next";

import {
  getStage2SessionToken,
  setStage2SessionToken,
} from "@/features/candidate-stage2/api";
import { useVideoConsentQuery } from "@/features/candidate-stage2/hooks";

export default function CandidateStage2Layout() {
  const { stage2Token } = useParams<{ stage2Token: string }>();
  const { i18n } = useTranslation();

  // Persist the URL token synchronously so children see it on first render (no effect race).
  if (stage2Token && getStage2SessionToken() !== stage2Token) {
    setStage2SessionToken(stage2Token);
  }

  const { data } = useVideoConsentQuery();

  useEffect(() => {
    if (data?.position_language) {
      void i18n.changeLanguage(data.position_language);
    }
  }, [data?.position_language, i18n]);

  return (
    <div className="candidate-shell min-h-screen w-full bg-background">
      <Outlet />
    </div>
  );
}
